module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-plus-white-28bbe64c15c03825dcd16778c69a7cfd.svg";